export interface ZhInsetTabOption<T extends string | number = string | number> {
    label: string;
    value: T;
}

/** 旧 Vue zhInsetTabs 的 React 对应物，保留 active/change 与右侧 tip 合同。 */
export function ZhInsetTabs<T extends string | number>({
    active,
    onChange,
    options,
    tip
}: {
    active: T;
    onChange: (value: T) => void;
    options: ZhInsetTabOption<T>[];
    tip?: string;
}) {
    return (
        <div className="zh-inset-tabs">
            <div aria-label="页内导航" className="zh-inset-tabs__list" role="tablist">
                {options.map(option => (
                    <button
                        aria-selected={active === option.value}
                        className={active === option.value ? "is-active" : undefined}
                        key={option.value}
                        onClick={() => onChange(option.value)}
                        role="tab"
                        type="button"
                    >
                        {option.label}
                    </button>
                ))}
            </div>
            {tip ? <div className="zh-inset-tabs__tip">{tip}</div> : null}
        </div>
    );
}
